<template>
  <div>
    <div v-for="(week, index) in timeCardCollection" :key="`week_${index}`">
      <timeCard
        v-for="(timeCard, cardIndex) in week.timeCards"
        v-bind:key="`timecard1_${employee.id}_${cardIndex}`"
        v-bind:index="cardIndex"
        v-bind:id="timeCard.id"
        v-bind:date="timeCard.date"
        v-bind:approved="timeCard.approved"
        v-bind:times="timeCard.times"
        v-bind:name="timeCard.name"
        v-bind:type="timeCard.type"
        v-bind:dateApproved="timeCard.dateApproved"
        v-bind:lastRegTime="timeCard.lastRegTime"
        v-bind:otIndex="timeCard.otIndex"
        v-bind:approvedBy="timeCard.approvedBy"
        v-bind:regularHours="timeCard.regularHours"
        v-bind:holidays="holidays"
        v-bind:vacation="timeCard.vacation"
        v-bind:showLocation="false"
        v-bind:uid="timeCard.uid"
        :passedEditComment="timeCard.editComment"
        :averagingAgreement="
          timeCard.averagingAgreement ? timeCard.averagingAgreement : null
        "
        @statCalculated="updateStat"
        :ref="`timeCardCollection_week${index}_${employee.id}`"
        style="display: none"
      ></timeCard>
    </div>
  </div>
</template>

<script>
import timeCard from '../../components/timeCard.vue';
import moment from 'moment';
import { getWeeksFromDateRange } from '../../assets/js/helpers/dates.js';

export default {
  name: 'reportCalculations',
  components: {
    timeCard
  },
  data() {
    return {
      tableData: null,
      totals: [],
      hoursWorkedTotals: [],
      jobSpecificTotals: [],
      hoursWorkedJobSpecificTotals: [],
      loading: null,
      lastRegTime: null,
      otIndex: null,
      statDaysWorked: null,
      statHoursWorked: null,
      statExemptDays: null,
      statExemptHours: null,
      statTime: null
    };
  },
  props: {
    employee: Object,
    timeCardCollection: Array,
    searchDate: Array,
    holidays: Array,
    holidaysInTimeSpan: Array
  },
  methods: {
    calculateEmployee: async function() {
      this.tableData = [];
      this.totals = [];

      let weeks = getWeeksFromDateRange(this.searchDate[0], this.searchDate[1]);
      for (let i = 0; i < weeks.length; i++) {
        await this.calculateTotals(
          moment(weeks[i].startOfWeek).startOf('day'),
          i
        );
      }
      this.$emit(
        'updateData',
        this.totals,
        this.tableData,
        this.employee,
        this.hoursWorkedTotals,
        this.jobSpecificTotals,
        this.hoursWorkedJobSpecificTotals
      );
    },

    calculateTotals: async function(startDate, weekCounter) {
      try {
        //get a list of the dates selected.
        let datesCollection = [];
        let startDateVar = moment(startDate).format('ddd, MMM, DD, YY');
        for (let i = 0; i < 7; i++) {
          datesCollection.push(
            moment(moment(startDateVar).add(i, 'days')).format(
              'ddd, MMM, DD, YY'
            )
          );
        }
        let tempTotals = {
          regularTotal: 0,
          total: 0,
          otTotal: 0,
          travelTimeTotal: 0,
          statTotal: 0,
          onCallHoursTotal: 0
        };

        let tempHoursWorkedTotals = {
          regularTotal: 0,
          total: 0,
          otTotal: 0,
          travelTimeTotal: 0,
          statTotal: 0,
          onCallHoursTotal: 0
        };

        let tempJobSpecificTotals = { regular: {}, ot: {} };
        let tempHoursWorkedJobSpecificTotals = { regular: {}, ot: {} };

        this.tableData.push({
          week: datesCollection,
          timeCards: []
        });

        //If the timecards for this week are not present yet then we need to wait for them

        let j = 0;

        while (this.timeCardCollection[weekCounter] === undefined && j < 200) {
          await new Promise(resolve => setTimeout(resolve, 1));
          j++;
        }

        //if there are no approved timecards for this week, then we need to create an array of 7 empty timecards.
        if (
          this.$refs[
            `timeCardCollection_week${weekCounter}_${this.employee.id}`
          ] === undefined
        ) {
          for (let i = 1; i <= 7; i++) {
            let printTimeCard = {
              totalHours: '',
              regularHours: '',
              otHours: '',
              travelTime: '',
              statTime: '',
              onCallHours: ''
            };
            this.tableData[weekCounter].timeCards.push(printTimeCard);
          }
        } else {
          //if there are timecards, we need to loop through them and start adding them up.
          for (
            let i = 0;
            i <=
            this.$refs[
              `timeCardCollection_week${weekCounter}_${this.employee.id}`
            ].length -
              1;
            i++
          ) {
            //If the timecard has an averaging agreement on it, it will take more time to load, so we have to wait for it
            let j = 0;
            if (
              this.$refs[
                `timeCardCollection_week${weekCounter}_${this.employee.id}`
              ][i].averagingAgreement !== null
            ) {
              while (
                this.$refs[
                  `timeCardCollection_week${weekCounter}_${this.employee.id}`
                ][i].hoursLoaded !== true &&
                j < 200
              ) {
                await new Promise(resolve => setTimeout(resolve, 1));
                j++;
              }
            }
            if (
              this.$refs[
                `timeCardCollection_week${weekCounter}_${this.employee.id}`
              ][i].approved
            ) {
              tempTotals.regularTotal += Number(
                this.$refs[
                  `timeCardCollection_week${weekCounter}_${this.employee.id}`
                ][i].regularHours
              );
              tempTotals.total += Number(
                this.$refs[
                  `timeCardCollection_week${weekCounter}_${this.employee.id}`
                ][i].total
              );
              tempTotals.otTotal += Number(
                this.$refs[
                  `timeCardCollection_week${weekCounter}_${this.employee.id}`
                ][i].otHours
              );
              tempTotals.travelTimeTotal += Number(
                this.$refs[
                  `timeCardCollection_week${weekCounter}_${this.employee.id}`
                ][i].travelTime
              );
              tempTotals.onCallHoursTotal += Number(
                this.$refs[
                  `timeCardCollection_week${weekCounter}_${this.employee.id}`
                ][i].onCallHours
              );
              //job specific totals
              for (const [key, value] of Object.entries(
                this.$refs[
                  `timeCardCollection_week${weekCounter}_${this.employee.id}`
                ][i].jobSpecificHoursSummary.regular
              )) {
                if (tempJobSpecificTotals.regular[`${key}`] === undefined) {
                  tempJobSpecificTotals.regular[`${key}`] = 0;
                }
                tempJobSpecificTotals.regular[`${key}`] += Number(value);
              }

              for (const [key, value] of Object.entries(
                this.$refs[
                  `timeCardCollection_week${weekCounter}_${this.employee.id}`
                ][i].jobSpecificHoursSummary.ot
              )) {
                if (tempJobSpecificTotals.ot[`${key}`] === undefined) {
                  tempJobSpecificTotals.ot[`${key}`] = 0;
                }
                tempJobSpecificTotals.ot[`${key}`] += Number(value);
              }

              //for the hours worked report, we need to add to the totals only if it is within the search date

              if (
                moment(
                  this.$refs[
                    `timeCardCollection_week${weekCounter}_${this.employee.id}`
                  ][i].date
                ).isBetween(
                  this.searchDate[0],
                  this.searchDate[1],
                  undefined,
                  '[]'
                )
              ) {
                tempHoursWorkedTotals.regularTotal += Number(
                  this.$refs[
                    `timeCardCollection_week${weekCounter}_${this.employee.id}`
                  ][i].regularHours
                );
                tempHoursWorkedTotals.total += Number(
                  this.$refs[
                    `timeCardCollection_week${weekCounter}_${this.employee.id}`
                  ][i].total
                );
                tempHoursWorkedTotals.otTotal += Number(
                  this.$refs[
                    `timeCardCollection_week${weekCounter}_${this.employee.id}`
                  ][i].otHours
                );
                tempHoursWorkedTotals.travelTimeTotal += Number(
                  this.$refs[
                    `timeCardCollection_week${weekCounter}_${this.employee.id}`
                  ][i].travelTime
                );
                tempHoursWorkedTotals.onCallHoursTotal += Number(
                  this.$refs[
                    `timeCardCollection_week${weekCounter}_${this.employee.id}`
                  ][i].onCallHours
                );

                // job specific hous worked totals
                for (const [key, value] of Object.entries(
                  this.$refs[
                    `timeCardCollection_week${weekCounter}_${this.employee.id}`
                  ][i].jobSpecificHoursSummary.regular
                )) {
                  if (
                    tempHoursWorkedJobSpecificTotals.regular[`${key}`] ===
                    undefined
                  ) {
                    tempHoursWorkedJobSpecificTotals.regular[`${key}`] = 0;
                  }
                  tempHoursWorkedJobSpecificTotals.regular[`${key}`] += Number(
                    value
                  );
                }

                for (const [key, value] of Object.entries(
                  this.$refs[
                    `timeCardCollection_week${weekCounter}_${this.employee.id}`
                  ][i].jobSpecificHoursSummary.ot
                )) {
                  if (
                    tempHoursWorkedJobSpecificTotals.ot[`${key}`] === undefined
                  ) {
                    tempHoursWorkedJobSpecificTotals.ot[`${key}`] = 0;
                  }
                  tempHoursWorkedJobSpecificTotals.ot[`${key}`] += Number(
                    value
                  );
                }
              }

              for (
                let x = this.tableData[weekCounter].timeCards.length;
                x < 7;
                x++
              ) {
                if (
                  !moment(
                    this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].date
                  ).isSame(datesCollection[x], 'day')
                ) {
                  let printTimeCard = {
                    totalHours: '',
                    regularHours: '',
                    otHours: '',
                    travelTime: '',
                    statTime: '',
                    onCallHours: ''
                  };
                  this.tableData[weekCounter].timeCards.push(printTimeCard);
                } else {
                  let printTimeCard = {
                    date: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].date,
                    name: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].name,
                    type: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].type,
                    totalHours: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].total,
                    regularHours: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].regularHours,
                    otHours: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].otHours,
                    travelTime: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].travelTime,
                    statTime: tempTotals.statTotal,

                    onCallHours: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].onCallHours,
                    times: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].formattedTimes,
                    comments: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].editComment,
                    jobSpecificHoursSummary: this.$refs[
                      `timeCardCollection_week${weekCounter}_${this.employee.id}`
                    ][i].jobSpecificHoursSummary
                  };

                  this.tableData[weekCounter].timeCards.push(printTimeCard);

                  break;
                }
              }
            }
          }
        }

        if (this.tableData[weekCounter].timeCards.length < 7) {
          for (
            let x = this.tableData[weekCounter].timeCards.length;
            x < 7;
            x++
          ) {
            let printTimeCard = {
              totalHours: '',
              regularHours: '',
              otHours: ''
            };
            this.tableData[weekCounter].timeCards.push(printTimeCard);
          }
        }
        this.totals.push({
          regularTotal: tempTotals.regularTotal.toFixed(2),
          otTotal: tempTotals.otTotal.toFixed(2),
          total: tempTotals.total.toFixed(2),
          travelTimeTotal: tempTotals.travelTimeTotal.toFixed(2),
          statTotal: tempTotals.statTotal.toFixed(2),
          onCallHoursTotal: tempTotals.onCallHoursTotal.toFixed(2)
        });
        this.hoursWorkedTotals.push({
          regularTotal: tempHoursWorkedTotals.regularTotal.toFixed(2),
          otTotal: tempHoursWorkedTotals.otTotal.toFixed(2),
          total: tempHoursWorkedTotals.total.toFixed(2),
          travelTimeTotal: tempHoursWorkedTotals.travelTimeTotal.toFixed(2),
          statTotal: tempHoursWorkedTotals.statTotal.toFixed(2),
          onCallHoursTotal: tempHoursWorkedTotals.onCallHoursTotal.toFixed(2)
        });

        Object.keys(tempJobSpecificTotals.regular).forEach(key => {
          tempJobSpecificTotals.regular[key] = Number(
            tempJobSpecificTotals.regular[key].toFixed(2)
          );
        });

        Object.keys(tempJobSpecificTotals.ot).forEach(key => {
          tempJobSpecificTotals.ot[key] = Number(
            tempJobSpecificTotals.ot[key].toFixed(2)
          );
        });

        Object.keys(tempHoursWorkedJobSpecificTotals.regular).forEach(key => {
          tempHoursWorkedJobSpecificTotals.regular[key] = Number(
            tempHoursWorkedJobSpecificTotals.regular[key].toFixed(2)
          );
        });

        Object.keys(tempHoursWorkedJobSpecificTotals.ot).forEach(key => {
          tempHoursWorkedJobSpecificTotals.ot[key] = Number(
            tempHoursWorkedJobSpecificTotals.ot[key].toFixed(2)
          );
        });

        this.jobSpecificTotals.push({
          regular: tempJobSpecificTotals.regular,
          ot: tempJobSpecificTotals.ot
        });

        this.hoursWorkedJobSpecificTotals.push({
          regular: tempHoursWorkedJobSpecificTotals.regular,
          ot: tempHoursWorkedJobSpecificTotals.ot
        });
      } catch (err) {
        console.log(err);
      }
    },
    //updateStat is emitted from the timecard component when a card has stat on it
    updateStat: function(
      val,
      index,
      date,
      uid,
      statHoursWorked,
      statDaysWorked,
      statExemptDays,
      statExemptHours,
      statError
    ) {
      let multipleStats;
      if (this.holidaysInTimeSpan.length > 1) {
        multipleStats = true;
      } else {
        multipleStats = false;
      }
      this.$emit(
        'updateStatTotals',
        multipleStats,
        statHoursWorked,
        statDaysWorked,
        statExemptDays,
        statExemptHours,
        statError
      );
      //update the stats and then add them to the table after everything is complete
      this.$emit('updateStatCards', val, index, date, uid, statHoursWorked, statDaysWorked, statExemptDays, statExemptHours);
    }
  },
  mounted() {
    this.calculateEmployee();
  }
};
</script>
